import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagCD = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M47.224 13.537a24.985 24.985 0 0 0-4.545-6.215 24.985 24.985 0 0 0-6.216-4.545L18.851 18.85 2.776 36.464a24.984 24.984 0 0 0 4.546 6.215 24.986 24.986 0 0 0 6.215 4.545L31.149 31.15l16.075-17.612Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M7.322 42.678a25.151 25.151 0 0 0 3.341 2.808l34.823-34.823a25.15 25.15 0 0 0-6.149-6.149L4.514 39.337a25.142 25.142 0 0 0 2.808 3.341Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M7.322 7.322C-.566 15.209-2.08 27.054 2.776 36.463L36.463 2.776C27.054-2.08 15.21-.565 7.322 7.322ZM42.678 42.678c7.888-7.887 9.402-19.733 4.546-29.141L13.537 47.222c9.409 4.856 21.254 3.342 29.141-4.545Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m13.323 7.608 1.349 4.152h4.366l-3.532 2.566 1.349 4.152-3.532-2.566-3.532 2.566 1.35-4.152-3.533-2.566h4.366l1.349-4.152Z"
}));
FlagCD.displayName = 'FlagCD';
export default withFlagWrapper(FlagCD);
//# sourceMappingURL=index.js.map